import React from "react";
import { LinkHashStatuses } from "../../../../common/types/PaymentTypes";
import AlreadyPaidToken from "./AlreadyPaidToken";
import ExpireToken from "./ExpireToken";
import UnavailableToken from "./UnavailableToken";
import PackageNotFoundToken from "./PackageNotFoundToken";


type Props = {
    linkStatus?: LinkHashStatuses
}
const RouteErrorByStatus = (props: Props) => {
    const { linkStatus } = props;

    if (linkStatus == "alreadypay") {
        return (
            <AlreadyPaidToken />
        );
    }
    else if (linkStatus == "expire") {
        return (
            <ExpireToken />
        );
    } else if (linkStatus == "unavailable" || linkStatus == "error") {
        return (
            <UnavailableToken />
        );
    } else if (linkStatus == "packageNotFound") {
        return (
            <PackageNotFoundToken />
        );
    }
    return (
        <div>

        </div>
    );
}
export default RouteErrorByStatus;